<template>
    <AppChartWrapper
        imageName="Post Reaction"
    >
        <h4 slot="title" class="subheading text-xs-left font-weight-regular section-title--color">
            Post Reaction
        </h4>
        <ReactionsBarChart
                class="pt-2"
                v-if="summaryReady"
                slot="chart"
                :chartData="postReactionChartData"
                :height="350"
                :options="postReactionChartOptions"
        />
    </AppChartWrapper>
</template>

<script>
	import ReactionsBarChart from "../ReactionsBarChart";
    import {abbrNum, thousandSeperator} from "@/utils";
    import moment from 'moment';
    import AppChartWrapper from "../AppChartWrapper";

	export default {
		components: {
			ReactionsBarChart,
            AppChartWrapper
		},

		props: {
			summaryData: {
				type: Object,
				default() {
					return {}
				},
				required: true,
			},

            summaryReady: {
				type: Boolean,
                required:true,
            }
		},

		data() {
			return {
				postReactionChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					layout: {
						padding: {
							top: 10,
							left: 10,
							right: 10,
							bottom: 15
						}
					},
					tooltips: {
						mode: 'label',
						callbacks: {
							afterTitle() {
								this.total = 0;
							},
							label(item, data) {
								const {label} = data.datasets[item.datasetIndex];
								const value = item.yLabel;
								this.total += parseInt(item.yLabel);
								return `${label}: ${thousandSeperator(value)}`;
							},
							footer() {
								return `Total: ${this.total}`;
							}
						}
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								barThickness: 20,
                                //barPercentage: 0.8
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 15,
									callback(value, index, values) {
										return abbrNum(value, 2)
									}
								}
							}
						]
					}
				},

				categoryColor: {
					like: "#558DFD",
					love: "#FF009D",
					haha: "#F9C02F",
					sad: "#32C5FF",
					wow: "#000000",
					angry: "#FF0100",
				},
			};
		},

		computed: {
			reactions(){
				return this.summaryData.reactions || {};
            },

            reactionsData(){
				let reactionsRange = {};
				let range = this.reactions.range_count || [];
				range.forEach(item => {
					reactionsRange[item.val] = ["like","love","haha","sad","wow","angry"].map(react => ({category:react, count: item[`total_${react}`]}))
                });
                return reactionsRange;
            },

			postReactionChartData() {
				const datasets = ['like', 'love', 'haha', 'sad', 'wow', 'angry'].map(category => {
					const backgroundColor = this.categoryColor[category];
					const label = category;
					const data = Object.values(this.reactionsData).map(reacts => {
						return reacts.find(react => react.category === category);
					})
						.map(react => react.count);
					return {
						backgroundColor,
						data,
						label
					};
				});
				const labels = Object.keys(this.reactionsData).map(label => moment(label).format('YYYY-MM-DD'));
				return {
					datasets, labels
				};
			}
		}
	}
</script>

<style scoped>
    .chart-container {
        width: 51vw;
        position: relative;
    }

    .chart-wrapper > div:first-child {
        margin-top: -14px;
        margin-left: -14px;
    }
</style>
